
import { Action } from '@ngrx/store';
import { YourPersonalDetails } from '../../model/ngrx/your-personal-details.model';
import * as YourPersonalDetailsActions from './../actions/your-personal-details.actions';

export type Actions = YourPersonalDetailsActions.Actions;

export function YourPersonalDetailsReducer(state: YourPersonalDetails[] = [], action: YourPersonalDetailsActions.Actions) {
    switch (action.type) {
        case YourPersonalDetailsActions.ADD_YOUR_PERSONAL_DETAILS:
            return [...state, action.payload];

        // Add this case:
        case YourPersonalDetailsActions.REMOVE_YOUR_PERSONAL_DETAILS:
            state = [];
            return state;

        default:
            return state;
    }
}
